const round2 = (n) => Math.round(Number(n || 0) * 100) / 100

// Cuanto tiene que haber pagado ESTE jugador para llegar al pago N.
//
// Sale de SUS cargos, no del precio de lista del plan: con un descuento paga
// menos, y comparando contra la lista terminaba de pagar su plan completo sin
// desbloquear nunca su uniforme.
//
// Una parcialidad que no le genero cargo cuenta por el monto del plan: un cargo
// que no se emitio no debe bajarle la barra.
export const umbralHastaOrden = (parcialidades = [], cargosPorParcialidadId = {}, hastaOrden = Infinity) => round2(
  (parcialidades || [])
    .filter((p) => Number(p.orden) <= Number(hastaOrden))
    .reduce((s, p) => {
      const cargo = cargosPorParcialidadId[p.id]
      return s + Number(cargo ? cargo.monto_final : (p.monto || 0))
    }, 0)
)

export const computeEntregableEstatus = (entregable, ctx) => {
  const { parcialidades = [], pagadoTotal = 0, cargosPorParcialidadId = {} } = ctx || {}
  const base = { nombre: entregable.nombre, regla_tipo: entregable.regla_tipo, hasta_orden: entregable.hasta_orden }

  if (entregable.regla_tipo === 'parcialidad') {
    const umbral = umbralHastaOrden(parcialidades, cargosPorParcialidadId, entregable.hasta_orden)
    const falta = round2(Math.max(0, umbral - Number(pagadoTotal || 0)))
    return { ...base, cubierto: falta === 0, falta_monto: falta }
  }

  // regla_tipo === 'concepto'
  const matchingParcs = parcialidades.filter((p) => p.concepto_id === entregable.concepto_id)
  const matchingCargos = matchingParcs.map((p) => cargosPorParcialidadId[p.id]).filter(Boolean)
  const cubierto = matchingParcs.length > 0 && matchingCargos.length === matchingParcs.length && matchingCargos.every((cargo) => cargo.estatus === 'pagado')
  const falta = cubierto ? 0 : round2(matchingCargos.reduce((s, cargo) => s + Math.max(0, Number(cargo.saldo || 0)), 0))
  return { ...base, cubierto, falta_monto: falta }
}
